// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cDfgDlI1UQWiO6vLJ5aN {
  box-shadow: 0px 0px 6px 0px rgba(24, 24, 24, 0.2);
  background-color: #FDFDFD;
  padding: 1rem;
  border-radius: 12px;
}
.cDfgDlI1UQWiO6vLJ5aN .fl_Z4SDoxmAg0ITPkF2X {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  align-items: center;
}
.cDfgDlI1UQWiO6vLJ5aN .fl_Z4SDoxmAg0ITPkF2X .YYHpi3pnFsSeg6P4VK9G {
  display: flex;
  align-items: center;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/componentes/ListaPesquisavelEntidades/ListaPesquisavelEntidades.module.scss"],"names":[],"mappings":"AAAA;EACI,iDAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AAAI;EACI,aAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AAGZ","sourcesContent":[".container {\r\n    box-shadow: 0px 0px 6px 0px rgba(24, 24, 24, 0.20);\r\n    background-color: #FDFDFD;\r\n    padding: 1rem;\r\n    border-radius: 12px;\r\n    .item {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        padding: 1rem;\r\n        align-items: center;\r\n        .contatoEQrCode {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 1rem;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export var container = `cDfgDlI1UQWiO6vLJ5aN`;
export var item = `fl_Z4SDoxmAg0ITPkF2X`;
export var contatoEQrCode = `YYHpi3pnFsSeg6P4VK9G`;
export default ___CSS_LOADER_EXPORT___;
